import React from 'react';
import Page from 'Core/components/Page';
import { useTranslation } from 'react-i18next';
import { useScrollTop } from 'Core/hooks/useScrollTop';
import Card from 'Core/components/FormElements/Card';
import useAlertStore, { alertSelector } from 'Core/stores/alert';
import { Alert } from 'Core/components/Alert';
import paperworkIllustration from 'Images/illustrations/paperwork.svg';
const ApplicationNotFound = () => {
  document.title = 'Payment Portal - Application Not Found';
  useScrollTop();
  const { t } = useTranslation();
  const alert = useAlertStore(alertSelector);

  return (
    <Page title={t('easyCredit.page.financing.header')} withStepProgress={false} stickyFooter hideAlert>
      <div className="mt-12 max-w-4xl mx-auto">
        <Card className="bg-gradient-to-br from-white to-gray-50 shadow-xl border-0 overflow-hidden">
          {/* Top accent bar */}
          <div className="h-2 bg-gradient-to-r from-amber-400 via-orange-400 to-amber-500"></div>
          
          <div className="p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Illustration */}
              <div className="flex-shrink-0 w-40 md:w-56">
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6 shadow-inner">
                  <img 
                    src={paperworkIllustration} 
                    alt="Paperwork illustration" 
                    className="w-full h-auto"
                  />
                </div>
              </div>
              
              {/* Content */}
              <div className="flex-1 text-center md:text-left">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-100 text-amber-800 rounded-full text-sm font-semibold mb-4">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  Application Not Found
                </div>
                
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                  {t('easyCredit.applicationNotFound.title')}
                </h2>
                
                <p className="text-lg text-gray-600 leading-relaxed">
                  {t('easyCredit.applicationNotFound.content')}
                </p>
              </div>
            </div>

            {/* Error Details Section */}
            {alert && (
              <div className="mt-10 pt-8 border-t border-gray-200">
                <div className="flex items-center gap-2 mb-4">
                  <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div className="text-gray-700 font-semibold text-lg">Error Details</div>
                </div>

                <Alert data-testid={`alert-${alert.type}`} type={alert.type} showIcon>
                  {alert.text}
                </Alert>
              </div>
            )}
          </div>
        </Card>
      </div>
    </Page>
  );
};

export default ApplicationNotFound;

